<script lang="ts" setup>
import { useService } from '@kaokei/use-vue-service';
import { ImService } from '../im.service';

const service = useService(ImService);
</script>

<template>
  <div
    class="im-header-bg flex h-[72px] flex-none select-none items-center justify-between px-6"
  >
    <div class="flex items-center justify-start">
      <a-avatar
        :size="48"
        :src="service.peer.avatar"
        :draggable="false"
        class="!border-none outline outline-1 outline-white"
      ></a-avatar>
      <div class="ml-3">
        <div class="text-base font-bold text-colorText">
          {{ service.peer.name }}
        </div>
        <div
          class="im-peer-status mt-1"
          :class="{ online: service.peerOnline }"
        >
          <div class="im-status-dot"></div>
        </div>
      </div>
    </div>
    <a-button type="text" shape="circle" @click="service.toggleEntry">
      <img src="@core/assets/image/im/icon-close.svg" alt="close" class="mx-auto" />
    </a-button>
  </div>
</template>

<style scoped>
.im-header-bg {
  background: #eef3ff linear-gradient(270.51deg, #e8f1ff 10.59%, #f3f4ff 95.13%);
}

.im-peer-status {
  font-size: 12px;
  line-height: 20px;
  width: 50px;
  height: 20px;
  border-radius: 20px;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}
.im-peer-status::after {
  content: '离线';
  font-size: 12px;
  @apply ml-1 text-colorTextTertiary;
}
.im-peer-status .im-status-dot {
  width: 10px;
  height: 10px;
  padding: 1px;
  background: #fff;
  border-radius: 50%;
  @apply border border-colorTextQuaternary;
}
.im-peer-status .im-status-dot::after {
  content: ' ';
  display: block;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  @apply bg-colorTextTertiary;
}

.im-peer-status.online::after {
  content: '在线';
  @apply text-success;
}
.im-peer-status.online .im-status-dot {
  @apply border-success/60;
}
.im-peer-status.online .im-status-dot::after {
  @apply bg-success;
}
</style>
